import { ReactNode } from 'react';
import { cn } from '../../utils';
import { LockClosedIcon } from '@heroicons/react/24/outline';
import Alli360Layout from '../Alli360Layout/Alli360Layout';
import { PaddedFullWidthContainer } from '../Alli360Layout/Containers';

type AccessDeniedLayoutProps = {
    title?: string;
    children: ReactNode;
};

type ContentProps = {
    title?: string;
    subtitle?: string;
    subtitle2?: string;
    accessType: 'accessDenied' | 'accessDeniedWithRequest';
};

export function AccessDeniedLayout({
    title,
    children,
}: AccessDeniedLayoutProps) {
    return (
        <Alli360Layout title={title}>
            <PaddedFullWidthContainer>{children}</PaddedFullWidthContainer>
        </Alli360Layout>
    );
}

const AccessDeniedDefaultContent = {
    accessDenied: {
        title: 'Whoops!',
        subtitle:
            'It looks like you don’t currently have access to this section.',
        subtitle2:
            'If you believe this is an error or you need access, please contact your Alli representative for assistance.',
    },
    accessDeniedWithRequest: {
        title: 'Whoops!',
        subtitle: "You don't have access to this client.",
        subtitle2: 'Request access or switch to an account with access.',
    },
};

export function Content({
    title,
    subtitle,
    subtitle2,
    accessType,
}: ContentProps) {
    const hasRequest = accessType === 'accessDeniedWithRequest';
    const finalTitle = title || AccessDeniedDefaultContent[accessType].title;
    const finalSubtitle =
        subtitle || AccessDeniedDefaultContent[accessType].subtitle;
    const finalSubtitle2 =
        subtitle2 || AccessDeniedDefaultContent[accessType].subtitle2;

    return (
        <>
            <div
                className={cn('alli-mb-4 alli-text-4xl alli-font-medium', {
                    'alli-mx-auto': !hasRequest,
                })}>
                {finalTitle}
            </div>
            <div
                className={cn('alli-text-base alli-font-semibold', {
                    'alli-mx-auto': !hasRequest,
                })}>
                {finalSubtitle}
            </div>
            <div
                className={cn('alli-text-base', {
                    'alli-mx-auto': !hasRequest,
                    'alli-max-w-[30rem]': !hasRequest,
                })}>
                {finalSubtitle2}
            </div>
        </>
    );
}

export function LockIcon() {
    return (
        <div
            className="alli-flex alli-w-32 alli-flex-col alli-items-center alli-justify-center alli-text-center"
            data-testid="lock-icon">
            <div className="alli-mb-4 alli-flex alli-h-32 alli-w-32 alli-items-center alli-justify-center alli-rounded-full alli-bg-gray-400">
                <LockClosedIcon className="alli-h-3/5 alli-w-3/5 alli-stroke-2 alli-text-blue-gray-700" />
            </div>
        </div>
    );
}
